<script setup lang="ts">
import { onMounted } from 'vue'

import appEnv from '@/support/env'

/**
 * Reports one visit. A component and not a function, because *when* it mounts is the whole
 * point: the `v-if` that renders it is what decides whether a visit is reported at all.
 */

interface AsgTracker {
  storeVisit: (params: Record<string, unknown>) => void
}

const SCRIPT_ID = 'asg-tr'

/** The tracker publishes itself on `window` some time after its script runs. */
const REPORT_DELAY_MS = 500

onMounted(() => {
  if (!appEnv.TRACKER_SCRIPT) return

  if (document.getElementById(SCRIPT_ID) === null) {
    const script = document.createElement('script')
    script.setAttribute('id', SCRIPT_ID)
    script.setAttribute('src', appEnv.TRACKER_SCRIPT)

    if (appEnv.TRACKER_DOMAIN) {
      script.dataset.trackingDomain = appEnv.TRACKER_DOMAIN
    }

    document.head.appendChild(script)
  }

  setTimeout(() => {
    const tracker = (window as unknown as { _asgTracker?: AsgTracker })
      ._asgTracker

    tracker?.storeVisit({})
  }, REPORT_DELAY_MS)
})
</script>

<template>
  <div class="tracking-pixel" />
</template>

<style lang="scss" scoped>
.tracking-pixel {
  display: none;
}
</style>
